const style = {
  input: {
    border: `2px solid #666`,
    borderRadius: `0px`,
    background: `white`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/News/partials/PostEditor/style/ColorBlind/input.js